// extracted by mini-css-extract-plugin
module.exports = {"container":"ArchivePagination_container__2V7VM","arrows":"ArchivePagination_arrows__3eSUd","leftArrow":"ArchivePagination_leftArrow__34MSB"};